import React from 'react';

export function positiveExpectedT0(value) {
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : null;
}
export function getExpectedT0(component, fallback) {
  return positiveExpectedT0(component?.validity?.inputs?.t0_predicted
    ?? component?.validity?.result?.t0_predicted ?? fallback);
}
export function expectedT0Line(value) {
  const expected = positiveExpectedT0(value);
  return expected == null ? [] : [{ key: 'expected-t0', x: expected, stroke: '#b45309',
    label: { value: `Expected t0 ${expected.toFixed(2)} s`, position: 'insideTopLeft', fontSize: 11 } }];
}
export function DerivedSizeTiming({ components = [], expectedT0 }) {
  const expected = getExpectedT0(components[0], expectedT0);
  return <section aria-label="Timing comparison" className="rounded-lg border bg-white p-4 space-y-2">
    <h4 className="font-semibold">Expected and fitted t0</h4>
    <p>{expected == null ? 'Expected t0 unavailable.' : `Expected t0: ${expected.toFixed(3)} s`}</p>
    {components.map((component, i) => {
      const expectedValue = getExpectedT0(component, expectedT0);
      const fitted = typeof component.t0 === 'number' && Number.isFinite(component.t0) ? component.t0 : null;
      const percent = expectedValue != null && fitted != null ? 100 * (fitted - expectedValue) / expectedValue : null;
      const deviation = Number.isFinite(percent) ? percent : null;
      const diagnostics = component.validity?.result;
      const warning = diagnostics?.t0_deviation_ok === false || ['caution', 'invalid'].includes(diagnostics?.t0_deviation_display_level);
      return <div key={`${component.peak_index}-${component.component_index}-${i}`} className={warning ? 'rounded bg-amber-50 p-2 text-amber-900' : 'text-sm text-slate-700'}>
        Peak {component.peak_index ?? '—'}, component {component.component_index ?? i + 1}: fitted t0 {fitted == null ? 'unavailable' : `${fitted.toFixed(3)} s`}; signed deviation {deviation == null ? 'unavailable' : `${deviation >= 0 ? '+' : ''}${deviation.toFixed(2)}%`}.
        {warning && <p>Timing warning: {diagnostics.t0_deviation_flag || 'Backend timing check flagged this component.'}</p>}
      </div>;
    })}
    <p className="text-xs text-slate-500">Signed deviation = 100 × (fitted − expected) / expected. Positive means later; negative means earlier. Timing warnings do not block preview or saving.</p>
  </section>;
}
